import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './contact.css';
import linkedin from '../../assets/linkedin.png';
// 
const Contact = () => {
    const [result, setResult] = useState('');

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending...");
        const formData = new FormData(event.target);

        formData.append("access_key", "7f63a9ed-2364-441c-9d24-4128eb196185");

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            event.target.reset();
            Swal.fire({
                title: "Thank you",
                text: "Form successfully sent.",
                icon: "success"
            });
            setResult('');
        } else {
            setResult("There was an error. Please try again later.");
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!"
            });
        }
    };

    return (
        <section className='contact' id='contact'>
            <div className='container mt-5'>
                <div className='text-center mb-3'>
                    <h1 className='introText'>Contact<span> Me</span></h1>
                </div>
                <div className='col-lg-12 d-flex justify-content-between align-items-center flex-wrap gap-2'>
                    <div className='col-lg-5 mb-3' data-aos="fade-up">
                        <h5>Get in <span className="introText">Touch</span></h5>
                        <p>
                            Feel free to reach out for project discussions or inquiries. 
                            Email me with any questions , I’ll be happy to answer.
                        </p>
                        <div className='mt-3'>
                            <h5>Email</h5>
                            <a href='mailto:ciddarthrm@gmail.com'>
                                <p>ciddarthrm@gmail.com</p>
                            </a>
                        </div>
                        <div className='mt-3'>
                            <h5>Mobile Number</h5>
                            <a href='tel:+919003054796'>
                                <p>+91 9003054796</p>
                            </a>
                        </div>
                        <a href='https://www.linkedin.com/in/ciddarthrm' aria-label="LinkedIn Profile">
                            <img src={linkedin} alt='LinkedIn' className='linkedin' width="30" />
                        </a>
                    </div>
                    <div className='col-lg-5 contact-bar' data-aos="fade-up">
                        <h5 className='mb-3'>Message me</h5>
                        <form onSubmit={onSubmit}>
                            <div className='input-box'>
                                <input type='text' className='field' placeholder='Your Name' name='name' id='name' required />
                            </div>
                            <div className='input-box'>
                                <input type='number' className='field' placeholder='Your Number' name='number' id='number' required />
                            </div>
                            <div className='input-box'>
                                <input type='email' className='field' placeholder='Your Email' name='email' id='email' required />
                            </div>
                            <div className='input-box'>
                                <textarea name='message' className='field mess' placeholder='Message...' id='message' required></textarea>
                            </div>
                            <button type='submit'>Send Message</button>
                            {result && <p className="form-result">{result}</p>}
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
